import { createLogic } from 'redux-logic';
import subscribeSendOnPeppolUpdates from "channels/sendOnPeppol";
import {  matchPath } from 'react-router-dom'

const subscribeSendOnPeppolLogic = createLogic({
  type: '@@router/LOCATION_CHANGE',
  process({ getState, action }, dispatch, done) {
    const initialMatch = matchPath(getState().router.location.pathname, { path: '/:officeSlug/*' })

    if (initialMatch) {
      var currentOfficeSlug = initialMatch.params.officeSlug;

      subscribeSendOnPeppolUpdates(currentOfficeSlug);
    }

    done();
  }
})

export default [subscribeSendOnPeppolLogic];
